import { Injectable } from '@angular/core'
import { EntitySignalStore } from '@awork/core/state/signal-store/entitySignalStore'
import { ProjectTemplate } from '@awork/features/project/models/project-template.model'

@Injectable({ providedIn: 'root' })
export class ProjectTemplateStore extends EntitySignalStore<ProjectTemplate> {
  constructor() {
    super({
      name: 'projectTemplate',
      entityConstructor: projectTemplate => new ProjectTemplate(projectTemplate),
      nullableProps: ['workflowId']
    })
  }

  preUpdateEntity(prevEntity: ProjectTemplate, nextEntity: Partial<ProjectTemplate>): Partial<ProjectTemplate> {
    // Preserve the tags from the previous entity if they are not present in the next entity
    const tags = nextEntity.tags || prevEntity.tags

    return { ...nextEntity, tags }
  }
}
